import { AUTHENTICATION_PROVIDER, AUTHENTICATION_URL_PARAMS, AuthType, forgeRefreshTokenCookie, forgeRevalidationCookie, shouldUseRegionPicker, } from '@innovyze/stylovyze/lib/types/authenticationContext.types';
import React, { useMemo } from 'react';
import { useAccessToken, useHasClientId, useHasCode, } from '@innovyze/stylovyze/lib/hooks/authStates';
import { Auth0Provider } from '../Auth0/';
import { ForgeProvider } from '../Forge';
import { LOGIN_STATUS_ENUM } from '@innovyze/stylovyze/lib/types/login.types';
import { Redirect } from 'react-router-dom';
import RedirectReloadable from './RedirectReloadable';
import { RegionPickerPromptProvider } from '@innovyze/stylovyze/lib/components/RegionPickerPrompt/RegionPickerPromptProvider';
import cookies from 'browser-cookies';
import { selectAuthenticationContext } from '@innovyze/stylovyze/lib/selectors/authenticationContext.selectors';
import { selectLoginContext } from '@innovyze/stylovyze/lib/selectors/login.selectors';
import useLogoutRoute from '@innovyze/stylovyze/lib/hooks/useLogoutRoute';
import { useSelector } from 'react-redux';
export default function AlternateAuthenticationWrapper({ children, authenticate = false, hasLoginPicker = false, hasSharedWorkers, }) {
    const { status } = useSelector(selectLoginContext);
    const { logoutRoute } = useLogoutRoute();
    const { token: tokenReduxState } = useSelector(selectAuthenticationContext);
    const accessTokenCookie = useAccessToken();
    const hasForgeRefreshToken = useMemo(() => {
        console.warn('LOGIN_V2: hasForgeRefreshToken', !!(cookies.get(forgeRefreshTokenCookie) &&
            cookies.get(forgeRevalidationCookie)));
        return !!(cookies.get(forgeRefreshTokenCookie) &&
            cookies.get(forgeRevalidationCookie));
    }, [
        cookies.get(forgeRefreshTokenCookie),
        cookies.get(forgeRevalidationCookie),
    ]);
    const authType = useMemo(() => typeof hasLoginPicker !== 'boolean'
        ? hasLoginPicker
        : localStorage.getItem(AUTHENTICATION_PROVIDER), [localStorage.getItem(AUTHENTICATION_PROVIDER)]);
    const hasCode = useHasCode();
    const hasClientId = useHasClientId();
    const authProvider = useMemo(() => {
        // When Authtype is forced, always use it
        if (authType && typeof authType !== 'boolean') {
            return authType;
        }
        if (accessTokenCookie) {
            if (authType === AuthType.Forge || hasForgeRefreshToken) {
                return AuthType.Forge;
            }
            return AuthType.Auth0;
        }
        if (hasCode || hasClientId || hasForgeRefreshToken || tokenReduxState) {
            if (authType === AuthType.Forge || hasForgeRefreshToken) {
                return AuthType.Forge;
            }
            return AuthType.Auth0;
        }
        const isAuthenticationUrl = !Object.values(AUTHENTICATION_URL_PARAMS).includes(window.location.pathname);
        if (isAuthenticationUrl && status !== LOGIN_STATUS_ENUM.AUTH_STAGE) {
            return 'redirect';
        }
        return null;
    }, [
        accessTokenCookie,
        authType,
        hasCode,
        hasClientId,
        hasForgeRefreshToken,
        status,
        tokenReduxState,
    ]);
    if (authProvider === AuthType.Forge) {
        if (localStorage.getItem(shouldUseRegionPicker)) {
            return (React.createElement(RegionPickerPromptProvider, { options: {
                    forceLogin: true,
                    authenticate,
                    redirectUri: window.location.origin + '/auth/forge/login',
                } }));
        }
        else
            return (React.createElement(ForgeProvider, { options: {
                    forceLogin: true,
                    authenticate,
                    redirectUri: window.location.origin + '/auth/forge/login',
                }, hasLoginPicker: !!hasLoginPicker, hasSharedWorkers: hasSharedWorkers },
                React.createElement(React.Fragment, null, children)));
    }
    if (authProvider === AuthType.Auth0) {
        return (React.createElement(Auth0Provider, { options: {
                forceLogin: false,
                authenticate,
                redirectUri: window.location.origin,
            }, hasLoginPicker: !!hasLoginPicker, hasSharedWorkers: hasSharedWorkers },
            React.createElement(React.Fragment, null, children)));
    }
    if (authProvider === 'redirect') {
        if (logoutRoute) {
            console.warn(`LOGIN_V2: redirect to ${logoutRoute}`);
            return React.createElement(RedirectReloadable, { to: logoutRoute, push: true, reload: true });
        }
        console.warn('LOGIN_V2: redirect to LOGIN PICKER');
        return React.createElement(Redirect, { to: AUTHENTICATION_URL_PARAMS.PICKER });
    }
    return React.createElement(React.Fragment, null);
}
